<template lang="html">
  <ul class="a7-pop-up-list">
    <li @click.stop="onClick()" @mouseenter.stop="selectOption(option)" v-for="option in filterOptions"
      class="a7-pop-up-menu-item">
      <span class="a7-pop-up-item" :class="itemClass(option.value)">
        {{option.label}}
      </span>
      <i v-if="filterOptions.length > 1" class="fa fa-chevron-right a7-icon"></i>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'a7-pop-up-menu-list',
  props: {
    list: Array,
    selectedOptions: Array
  },
  data() {
    return {
      options: [],
      preSelecao: null,
      selecionado: ''
    }
  },
  computed: {
    filterOptions() {
      return [...this.list.filter(i => !this.selectedOptions.includes(i.value))]
    }
  },
  methods: {
    itemClass(option) {
      return {
        'a7-pop-up-item': true,
        'a7-selected-item': option === this.selecionado
      }
    },
    selectOption(option) {
      const vm = this
      vm.selecionado = option.value
      vm.$emit('selectedOption', null)
      setTimeout(() => {
        if (vm.selecionado === option.value) {
          vm.$emit('selectedOption', option.value)
        }
      }, 200);
    },
    onClick() {
      this.$emit('emitValues')
    }
  }
}
</script>

<style lang="scss">

.a7-pop-up-list {
  margin-bottom: 0;
  padding-left: 10px;
  min-width: 150px;
}

.a7-pop-up-menu-item {
  padding: 5px;
  position: relative;
  display: block;
  border: none;
}

.a7-pop-up-item {
  cursor: pointer;
}

.a7-icon {
  float: right;
  padding: 4px 0;
  color: #4d52584f;
}

.a7-selected-item {
  color: #0088ce;
}

</style>
